module.exports = {"data":{"site":{"siteMetadata":{"title":"Smoothielicious"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 88
// module chunks = 60335399758886 114276838955818